module.exports = __webpack_public_path__ + "static/media/diary-5.b1c3dc7f.png";